import * as Yup from "yup";

export const vendorBuyOrder  = Yup.object().shape({
    vendorName: Yup.string(),
    vendorAddress: Yup.string(),
    vendorState: Yup.string(),
    pincode: Yup.string(),
    contactNumber: Yup.string(),
    cropName: Yup.string(),
    vendorOfferPricePerKg: Yup.string(),
    vendorRequirement: Yup.number().positive("Must be positive"),
    requirementDeadline: Yup.string(),
    repativeOrder: Yup.string(),
    vendorRequirementUnit: Yup.string(),
    customDeadlineDate: Yup.string().when("requirementDeadline", {
        is: "custom",
        then: (schema) => schema.required("Custom date is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
})
